import { mapGetProperties } from "utils/formatterArray";
import fetchAxios from "./http";

function filterPropertiesWithEmphasys(properties: Record<string, any>[]): Record<string, any>[] {
    return properties.filter(property => property.emphasys === true);
}

function filterPropertiesWithNonZeroUniqueValue(properties: Record<string, any>[]): Record<string, any>[] {
    return properties.filter(property => property.uniqueValue !== 0);
}

export const fetchAccommodations = async () => {
    const { data } = await fetchAxios.post(`accommodations`, {
        "checkIn": "",
        "checkOut": "",
        "home": true
    });

    let mappedProperties = mapGetProperties(data.data);

    const propertiesWithNonZeroUniqueValue = filterPropertiesWithNonZeroUniqueValue(mappedProperties);
    let sortedProperties = propertiesWithNonZeroUniqueValue.sort((a, b) => a.uniqueValue - b.uniqueValue);

    let propertiesWithEmphasys = filterPropertiesWithEmphasys(propertiesWithNonZeroUniqueValue);
    let sortedPropertiesWithEmphasys = propertiesWithEmphasys.sort((a, b) => a.uniqueValue - b.uniqueValue);
    return {
        promotionalUnits: sortedProperties.slice(0, 9),
        units: sortedPropertiesWithEmphasys.slice(0, 9),
    };
}